import { Entity } from './types'

export const headerCellsProps = {
  [Entity.Count]: { alignLeft: true, width: 80 },
  [Entity.Category]: { alignLeft: true, minWidth: 350 },
  [Entity.Students]: { alignRight: true },
  [Entity.Compensation]: { alignRight: true },
  [Entity.TotalRow]: { alignRight: true },
}


export const createHeaderCellsProps = () => {
  return new Proxy(headerCellsProps, {
    get: function (target, property) {
      const res = target[property as string]
      if (!res) {
        return {}
      }
      return res || {}
    },
  })
}
